import {
  getSiteConfig,
  getTranslations,
  getPerson,
  getPersonSlugs,
} from '@sh24/contentful-service'
import { previewClient, contentDeliveryClient } from '../../services/contentful'
import mapSlugsToPaths from '../../utils/map-slugs-to-paths'
import PersonTemplate from '../../templates/person-template'
import doStaticGeneration from '../../utils/do-static-generation'

const Person = ({ person }) => (
  <PersonTemplate person={person} />
)

export async function getStaticProps({ preview, params }) {
  const client = preview ? previewClient : contentDeliveryClient
  const { slug } = params
  const siteConfig = await getSiteConfig({ client })
  const translations = await getTranslations({ client })
  const person = await getPerson({ client, slug, include: 1 })

  return {
    props: {
      key: person?.id,
      preview: !!preview,
      siteConfig,
      translations,
      person,
    },
    revalidate: parseInt(process.env.REVALIDATE_WINDOW, 10),
    notFound: !person,
  }
}

export async function getStaticPaths() {
  let paths = []

  if (doStaticGeneration()) {
    const client = contentDeliveryClient
    const slugs = await getPersonSlugs({ client })

    paths = mapSlugsToPaths({ routes: ['slug'], slugs })
  }

  return {
    paths,
    fallback: 'blocking',
  }
}

export default Person
